import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col, Container } from "react-bootstrap";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";

const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({ increment, counter, mekhraz }) {
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const [title, setTitle] = useState(""); // useState hook
  const [error, setError] = useState(false);
  const [advType, setAdvType] = useState([]);
  const [newPirsom, setNewPirsom] = useState({
    pirsom_date: null,
    adv_type: 1,
    link: "",
    mekhraz: mekhraz.id,
  });

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "advtype/", {
          signal: controller.signal,
        });
        isMounted && setAdvType(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  }, []);
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;

    setNewPirsom((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDDSChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const n = Number(value);
    setNewPirsom((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "advertising/",
          newPirsom,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
    setTitle("");
    setError(false);
  };
  // render

  return (
    <Container>
      <HelpModal />
      <center>
        <div className="card text-dark bg-light container p-3  border">
          <div className="card-header">
            <h3
              onClick={() => {
                setSaeef("6");
                setShowHelp(true);
              }}
            >
              פרסומים של המכרז: {mekhraz.title}
              <span className="help">
                <MdLiveHelp />
              </span>
            </h3>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="adv_type">סוג הפרסום</label>
                    <br />
                    <select
                      name="adv_type"
                      onChange={handleDDSChange}
                      value={newPirsom.adv_type}
                    >
                      <option value="" selected>
                        בחר סוג
                      </option>
                      {advType?.map((a) => (
                        <option key={a.id} value={a.id}>
                          {a.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <br></br>
                  <div className="form-group">
                    <label htmlFor="adv_date">מועד הפרסום</label>
                    <input
                      type="date"
                      name="adv_date"
                      value={newPirsom.adv_date}
                      onChange={handleChange}
                      className="form-control"
                      id="adv_date"
                      placeholder="22-8-2022"
                    />
                  </div>

                  <label htmlFor="link">קישור </label>
                  <input
                    type="text"
                    style={{ maxWidth: "500px" }}
                    name="link"
                    value={newPirsom.link}
                    onChange={handleChange}
                    className="form-control"
                    id="link"
                    placeholder="http://a.com"
                  />
                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף
                  </button>
                </form>
              </Col>
            </Row>
          </div>
        </div>
      </center>
    </Container>
  );
}
